import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAndStoreChannelCategories } from '../../utils';
import { useChannelCategory } from '../../../Slice';

function ChannelCategory(prop) {
   const { channelId, channelStatus } = prop;
   const selectedcategory = useChannelCategory(channelId);
   const dispatch = useDispatch();
   const categoriesState = useSelector(state => state.channelCategory.categories);


   let categoryName = '';
   if (selectedcategory?.categoryId) {
      const found = categoriesState.find(cat => cat.id === Number(selectedcategory?.categoryId));
      categoryName = found ? found.category : '';
   } else if (selectedcategory?.category && selectedcategory?.category.category) {
      categoryName = selectedcategory?.category.category;
   }

   // Truncate and tooltip logic
   let displayName = categoryName;
   let showTooltip = false;
   if (channelStatus === 'explore' && categoryName.length > 15) {
      displayName = categoryName.slice(0, 15) + '...';
      showTooltip = true;
   }

   return (
      <pre
         className="channel_category_text"
         title={showTooltip ? categoryName : undefined}
         style={{ cursor: showTooltip ? 'pointer' : 'default' }}
      >
         {displayName}
      </pre>
   );
}

export default ChannelCategory;

ChannelCategory.propTypes = {
   channelId: PropTypes.string,
   channelStatus: PropTypes.string,
};